import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { startSyncWorker } from './shared/offline/syncWorker';
import './index.css';

// Kick off the offline write drainer once at boot. Safe to call in dev — it
// no-ops if the browser is offline and installs a single `online` listener.
startSyncWorker();

const root = createRoot(document.getElementById('root')!);
root.render(
  <StrictMode>
    <Suspense fallback={<div className="p-8 text-muted-foreground">Loading…</div>}>
      <App />
    </Suspense>
  </StrictMode>,
);
